import { ajax } from '@/api/ajax';

export interface OpenSecondChannelVo {
  channelId: number;
  channelName: string;
}

export function listSecondChannels() {
  return ajax<OpenSecondChannelVo[]>({
    url: '/api/tis/web/sip/notice/listSecondChannels',
    method: 'post',
    data: {}
  });
}
